import { Colors } from 'baseStyles/enums/colors'
import React from 'react'
import Button from 'schoolUiComponents/basic/Button'
import GCIconSVG from '../../assets/gc-icon.svg'
import Text from 'schoolUiComponents/basic/Text'
import Box from 'schoolUiComponents/basic/Box'
import FlexBox from 'schoolUiComponents/basic/Box/FlexBox'
import TeacherSignupStyles from '../../style';
import { pushEventToGTM } from '../../../commonHelpers/pushEventToGTM'
import { getSignupMethod } from '../../utils';
import useSignupCookie from 'hooks/useSignupCookie'

const GoogleButton = () => {

    const themeStyles = TeacherSignupStyles();

    const system_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const { setCookie } = useSignupCookie();
    
    const onGoogleClickHandler = () => { 
        // Setting cookie with signup
        setCookie('userSignedUp', 'true', {
            path: '/',
            secure: true,
            sameSite: 'Strict'
        });
        pushEventToGTM('clicked_teacher_signup_cta', { 'Click Text': 'Sign up' ,'Parent Signup Method': getSignupMethod()});
        // [AI GENERATED CODE] — Set pending source before OAuth redirect so createSession picks it up on return.
        if (typeof (window as any).MUS !== 'undefined') (window as any).MUS.setPendingSource('oauth');
        window.location.href = `${window.location.origin}/users/auth/google_oauth2?source=web&amp;type=teacher&amp;time_zone=${system_timezone}`;
    }
    
    return (
        <FlexBox
            flex={1} 
            width={themeStyles.socialButtons?.width}
            margin={themeStyles.socialButtons.margin}
            className='google'
            data-clicked="Clicked Google Signup" 
            data-onclick-url="/users/auth/google_oauth2?source=web&amp;type=teacher" 
            data-frompage="Signup Screen" 
            data-track="false" 
            data-clickedon="Google Signup" 
            data-directform="false" 
            data-provider="google" 
            data-networkname="Google"
            {...themeStyles.socialCtaBtns}    
        >
            <Button
                primary
                width={`100%`}
                height="58px"
                onClick={onGoogleClickHandler}
                backgroundColor={Colors.DARK_BLACK}
                hover={{ backgroundColor: Colors.DARK_BLACK_1, cursor: 'pointer' }}
                dataTestId="social-auth-btn-google"
            >
                <FlexBox center fullWidth>
                    <GCIconSVG />
                    <Box margin={`0 0 0 10px`}>
                        <Text.H4 color={Colors.WHITE}>
                            Sign up with Google
                        </Text.H4>
                    </Box>
                </FlexBox>
            </Button>
        </FlexBox>
    )
}

export default GoogleButton